import { captureException } from '@sentry/react'
import { z } from 'zod'
import axios from '@/axios-instance-node'
import { parseResponseData } from '@/helpers/utils'
import { ViewOnlySubGeoSchema } from '../types'

export interface HttpGetViewOnlySubgeosParams {
	geoId: string
}

const ViewOnlySubgeosResponse = z.array(ViewOnlySubGeoSchema)

export const httpGetViewOnlySubgeos = async (
	params: HttpGetViewOnlySubgeosParams
) => {
	const response = await axios.get('/v1/geo-mapping-sub-geos', {
		params: {
			type: 'view_only',
			geoId: params.geoId
		}
	})

	return parseResponseData({
		responseData: response.data,
		responseShape: ViewOnlySubgeosResponse,
		onZodError: captureException
	})
}
